import {
  Add,
  ArrowBack,
  ArrowForward,
  Delete,
  Edit,
} from "@mui/icons-material";
import {
  Alert,
  Box,
  Button,
  Card,
  CardContent,
  CardHeader,
  Divider,
  Grid,
  IconButton,
  Pagination,
  PaginationItem,
  Paper,
  Skeleton,
  Snackbar,
  TextField,
  Tooltip,
  Typography,
  useMediaQuery,
} from "@mui/material";
import axios from "axios";
import React, { useEffect, useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuid } from "uuid";
import CustomAutoComplete from "../../../CustomComponents/CustomAutoComplete";
import CustomDataGrid from "../../../CustomComponents/CustomDataGrid";
import GetBranchArray from "../../../CustomComponents/GetBranchArray";
import GetBranchDetailsWithCode from "../../../CustomComponents/GetBranchDetailsWithCode";
import NoDataFound from "../../../CustomComponents/NoDataFound";
import { CommonShortCutAction } from "../../../Store/CommonShortCutsReducer";
import { DisbursementBalanceTransferReducerAction } from "../../../Store/DisbursementBalanceTransfer/DisbursementBalanceTransferReducer";
import store from "./../../../Store/index";
import dayjs from "dayjs";
import ConvertBase64ToFile from "../../../CustomComponents/ConvertBase64ToFile";

const BalanceTransfer = (props) => {
  //Importing Hooks
  const dispatch = useDispatch();
  //Selectors from redux store
  const losCustomerData1 = useSelector(
    (state) => state.disbursementLosCustomerData.losCustomerData
  );
  const [losCustomerData, setLosCustomerData] = useState(losCustomerData1)
  const datarows = useSelector(
    (state) => state.disbursementBalanceTransfer.gridRows
  );
  const totalDeductions = useSelector(
    (state) => state.disbursementBalanceTransfer.totalDeductions
  );
  const totalDeductionsTabLoadingActive = useSelector(
    (state) => state.disbursementBalanceTransfer.totalDeductionsTabLoadingActive
  );
  const activePageNumber = useSelector(
    (state) => state.disbursementBalanceTransfer.activePageNumber
  );

  const validGridRecordsAsNonEditable = useSelector(
    (state) => state.disbursementBalanceTransfer.validGridRecordsAsNonEditable
  );

  const currentRowPaymentMode = useSelector(
    (state) => state.disbursementBalanceTransfer.currentRowPaymentMode
  );
  const currentGridPaymentModes = useSelector(
    (state) => state.disbursementBalanceTransfer.currentGridPaymentModes
  );
  const chequeModesArray = useSelector(
    (state) => state.disbursementBalanceTransfer.chequeModes
  );
  const chequePrintAtArray = useSelector(
    (state) => state.disbursementBalanceTransfer.chequePrintAt
  );

  const currentRowShflBankBranches = useSelector(
    (state) => state.disbursementBalanceTransfer.currentRowShflBankBranches
  );

  const disbursementLovData = useSelector(
    (state) => state.disbursementBalanceTransfer.disbursementLovData
  );
  const currentRowChequePrintAtArray = useSelector(
    (state) => state.disbursementBalanceTransfer.currentRowChequePrintAt
  );

  const bankAccountNums = useSelector(
    (state) => state.disbursementBalanceTransfer.bankAccountNums
  );
  const [gridColumns, setGridColumns] = React.useState([]);

  // branches with code
  const [branchNamesWithCodes, setBranchNamesWithCodes] = useState([]);
  const userName = useSelector((state) => state.branch.userName);

  const [deleteOperationActive, setDeleteOperationActive] =
    React.useState(false);

  const [rows, setRows] = React.useState([]);
  const [accordianOpen, setAccordianOpen] = React.useState(true);
  const [page, setPage] = React.useState(1);
  const rowsPerPage = 10;
  const [totalPageCount, setTotalPageCount] = React.useState(0);
  const [totalRowsCount, setTotalRowsCount] = React.useState(0);
  const loading = useSelector(
    (state) => state.disbursementBalanceTransfer.gridAreaSkeletonLoading
  );

  // max value 1200 -> mobile.
  const [deviceMode, setDeviceMode] = React.useState("");
  const deviceModeValue = useMediaQuery("(max-width:1200px)");

  // load the user account branches.
  const branchNames = GetBranchArray();

  //SnackBar Handler
  const [message, setMessage] = useState("");
  const [alertType, setAlertType] = useState("success");
  const [snackBarState, setSnackBarState] = React.useState({
    vertical: "bottom",
    horizontal: "left",
  });
  const { vertical, horizontal } = snackBarState;
  const [alert, setAlert] = useState(false);

  //
  //shortcut key
  const addRowRef = useRef(null);
  const cancelRef = useRef(null);
  const yesRef = useRef(null);

  useEffect(() => {
    // true -> mobile or tab, false -> desktop
    let SnackPosition = {
      vertical: deviceModeValue ? "top" : "bottom",
      horizontal: deviceModeValue ? "right" : "left",
    };
    setSnackBarState(SnackPosition);

    window.addEventListener("keydown", onKeyUnmountEventHandler);
    window.addEventListener("keyup", onKeyPressEventHandler);
    return () => {
      window.removeEventListener("keydown", onKeyUnmountEventHandler);
      window.removeEventListener("keyup", onKeyPressEventHandler);
    };
  }, [activePageNumber]);

  const onKeyPressEventHandler = (event) => {
    let charCode = String.fromCharCode(event.which).toLowerCase();

    if (event.ctrlKey) {
      if (charCode === "a") {
        addRowRef.current.click();
      } else if (charCode === "q") {
        cancelRef.current.click();
      } else if (charCode === "y") {
        yesRef.current.click();
      }
    }
  };
  const onKeyUnmountEventHandler = (event) => {
    if (event.ctrlKey) {
      dispatch(
        CommonShortCutAction.removeDefaultShortCutValue({
          event: event,
          screen: "disbursementCreate",
        })
      );
    }
  };

  useEffect(() => {
    // frequency of add or delete creates a performance issue of rerender.
    setDeleteOperationActive(true);
    dispatch(
      DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(true)
    );
    const branchCodes = GetBranchDetailsWithCode();
    setBranchNamesWithCodes(branchCodes);
    setDeviceMode(deviceModeValue ? "MOBILE" : "DESKTOP");
    setRows([...datarows].slice(0, 10));
    setTotalPageCount(
      datarows.length % 10 !== 0
        ? Number(Number((datarows.length / 10).toString().split(".")[0]) + 1)
        : Number(Number((datarows.length / 10).toFixed()))
    );
    setTotalRowsCount(datarows.length);
    setPage(1);
    setTimeout(() => {
      // frequency of add or delete creates a performance issue of rerender.
      setDeleteOperationActive(false);
      dispatch(
        DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(
          false
        )
      );
    }, 1000);
  }, [datarows, currentRowChequePrintAtArray, gridColumns]);

  useEffect(() => {
    if (
      Object.keys(disbursementLovData?.lovDataValue).length > 0 &&
      disbursementLovData?.lovDataValue?.["Payment Mode"]
    ) {
      const paymentLovValues = [
        ...disbursementLovData?.lovDataValue?.["Payment Mode"],
      ];
      let paymentModeValues = [];
      paymentLovValues.forEach((record) => {
        if (record.lovValues === "NEFT/RTGS") {
          paymentModeValues = paymentModeValues.concat(["NEFT", "RTGS"]);
        } else {
          paymentModeValues.push(record.lovValues);
        }
      });
      dispatch(
        DisbursementBalanceTransferReducerAction.updateCurrentGridPaymentModes(
          paymentModeValues
        )
      );
    } else {
      dispatch(
        DisbursementBalanceTransferReducerAction.updateCurrentGridPaymentModes(
          []
        )
      );
    }
  }, [disbursementLovData]);

  useEffect(() => {
    let updatedColumns = [...columns].map((col) => {
      if (col.field === "paymentMode") {
        col.valueOptions = currentGridPaymentModes;
      }
      return col;
    });
    if (currentRowPaymentMode) {
      if (
        currentRowPaymentMode === "NEFT" ||
        currentRowPaymentMode === "RTGS"
      ) {
        const nonEditableColumns = [
          "chequeNum",
          "chequeMode",
          "chequePrintAt",
          "chequePrintLocation",
          "chequeShflLocation",
          "chequeAllocationMode",
          "payableAt",
          "bankBranchGl",
          "deductionAmount",
          "disbAmt",
          // neft columns that to be disabled
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountType",
        ];
        updatedColumns = [...updatedColumns].map((col) => {
          if (col.field === "bankAccountNum") {
            col.valueOptions = bankAccountNums;
          }
          col.editable = !nonEditableColumns.includes(col.field);
          return col;
        });
        setGridColumns([...updatedColumns]);
      } else if (currentRowPaymentMode === "DD") {
        const nonEditableColumns = [
          "chequeNum",
          "chequeMode",
          "chequePrintAt",
          "chequePrintLocation",
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountNum",
          "bankAccountType",
          "chequeAllocationMode",
          "chequeShflLocation",
          "bankBranchGl",
          "deductionAmount",
          "disbAmt",
        ];
        updatedColumns = [...updatedColumns].map((col) => {
          col.editable = !nonEditableColumns.includes(col.field);
          return col;
        });
        setGridColumns([...updatedColumns]);
      } else {
        // cheque mode.
        const nonEditableColumns = [
          "payableAt",
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountNum",
          "bankAccountType",
          // few columns also need to be non editable in cheque by default are below
          "chequeNum",
          "bankBranchGl",
          "deductionAmount",
          "disbAmt",
        ];
        updatedColumns = [...updatedColumns].map((col) => {
          if (col.field === "chequePrintAt") {
            col.valueOptions = [...chequePrintAtArray];
          }
          col.editable = !nonEditableColumns.includes(col.field);
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
    } else {
      setGridColumns([...updatedColumns]);
    }
  }, [
    chequePrintAtArray,
    bankAccountNums,
    currentRowShflBankBranches,
    currentRowPaymentMode,
    currentGridPaymentModes,
    validGridRecordsAsNonEditable,
  ]);

  useEffect(() => {
    const getChequePrintAtValues = async () => {
      const chequePrintAtResponse = await axios.post(
        "/disbursement/getChequePrintAt",
        {
          apiCode: "CHEQUE_PRINT_AT_API",
          createdBy: userName,
          lastModifiedBy: userName,
        }
      );
      if (Object.keys(chequePrintAtResponse.data).length > 0) {
        const chequePrintAtValues =
          Number(chequePrintAtResponse.data.status) === 1
            ? chequePrintAtResponse.data.cheque_print_dtls
            : [];
        const printAtValues = chequePrintAtValues.map(
          (value) => value.print_at_desc
        );
        dispatch(
          DisbursementBalanceTransferReducerAction.updateChequePrintAtArray([
            ...printAtValues,
          ])
        );
      }
    };
    const getBankNameValues = async () => {
      try {
        const bankNamesResponse = await axios.post(
          "/filereceipt/getDraweerBanks",
          {
            apiCode: "BANK_LIST_SHFL_API",
            createdBy: userName,
            lastModifiedBy: userName,
          }
        );

        if (Object.keys(bankNamesResponse.data).length > 0) {
          const bankNameswithCodes =
            Number(bankNamesResponse.data.status) === 1
              ? bankNamesResponse.data.bank_list
              : [];
          dispatch(
            DisbursementBalanceTransferReducerAction.updateBankNamesWithCodes([
              ...bankNameswithCodes,
            ])
          );
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    };
    // getBankNameValues();
    getChequePrintAtValues();
    let latestRecords = store.getState().disbursementBalanceTransfer.gridRows;
    if (latestRecords.length === 0 && props.screenMode === "VIEW") {
      // get the balance transfer records from the disbursement favours object from tab value.
      let gridrecords = props.disbursementDetailTabValue?.disbursementFavours;
      gridrecords = [...gridrecords].map((row) => {
        let record = { ...row };
        record.id = record.disbAccountKey;
        record.amount = record.totalDisbAmt;
        record.disbAmt = record.disbAmt;
        record.favouringName = record.accHoldrName;
        record.bankBranchShflBank = record.bankBranch;
        if (record.docName && record.docData) {
          record.handOverFile = record.docName;
          const arrayFileString = String(record.docData).split(";base64,");
          const base64StringValue = arrayFileString[1];
          const fileType = arrayFileString[0].split("data:");
          const uploadedFile = ConvertBase64ToFile(
            base64StringValue,
            record.docName,
            fileType[1]
          );
          const fileData = Object.assign(uploadedFile, {
            preview: URL.createObjectURL(uploadedFile),
          });
          record.handOverFiles = [fileData];
        } else {
          record.handOverFile = null;
          record.handOverFiles = [];
        }
        return record;
      });
      dispatch(
        DisbursementBalanceTransferReducerAction.updateGridRows([
          ...gridrecords,
        ])
      );
      dispatch(
        DisbursementBalanceTransferReducerAction.updateGridAreaSkeletonLoading(
          false
        )
      );
    } else {
      dispatch(
        DisbursementBalanceTransferReducerAction.updateGridAreaSkeletonLoading(
          false
        )
      );
    }
  }, [currentRowPaymentMode]);

  useEffect(() => {
    const getShflBankBranch = async () => {
      try {
        const shflBanksResponse = await axios.post(
          "/disbursement/getShflBankBranches",
          {
            apiCode: "BANK_CASH_ACCOUNT_API",
            createdBy: userName,
            lastModifiedBy: userName,
            branchCodes: [losCustomerData?.branchCode],
            applicationNum: losCustomerData?.applicationNum,
          }
        );
        if (Object.keys(shflBanksResponse.data).length > 0) {
          const depositBanks = shflBanksResponse.data;
          dispatch(
            DisbursementBalanceTransferReducerAction.updateShflBankBranches({
              ...depositBanks,
            })
          );
          const shflBranches =
            depositBanks[losCustomerData.branchCode].ledger_details;
          // const bankNames = shflBranches.map((record) => record.branch_name);

          // new spec dated 28 Aug 2024 to load only one by default for all payment modes.
          const mandatoryDefaultShflBankBranch = ["LFSL095"];
          const bankNames = shflBranches
            .filter((record) =>
              mandatoryDefaultShflBankBranch.includes(record.gl_account)
            )
            .map((record) => record.branch_name);
          dispatch(
            DisbursementBalanceTransferReducerAction.updateCurrentRowShflBankBranches(
              [...bankNames]
            )
          );
        }
      } catch (error) {
        console.log(error);
        throw Error(error);
      }
    };
    const getCustomerBankDetailsByApplicationNum = async () => {
      const customerBankDetailsResponse = await axios.post(
        "/losCustomer/getCustBankDetailsByAppNum",
        {
          applicationNum: losCustomerData.applicationNum,
        }
      );
      const bankDetailsArray = [...customerBankDetailsResponse.data];
      const bankAccountNumsData =
        bankDetailsArray.length > 0
          ? bankDetailsArray.map((record) => record.bankAccountNum)
          : [];
      dispatch(
        DisbursementBalanceTransferReducerAction.updateCustomerBankDetails(
          bankDetailsArray
        )
      );
      dispatch(
        DisbursementBalanceTransferReducerAction.updateBankAccountNums(
          bankAccountNumsData
        )
      );
    };
    if (Object.keys(losCustomerData).length > 0) {
      getCustomerBankDetailsByApplicationNum();
      getShflBankBranch();
    }
  }, [currentRowPaymentMode, losCustomerData]);

  useEffect(() => {
    let latestRecords = store.getState().disbursementBalanceTransfer.gridRows;
    if (
      latestRecords.length === 0 &&
      props.screenMode === "CREATE" &&
      !totalDeductionsTabLoadingActive
    ) {
      gridRowAddButtonHandler(true);
    }
  }, [totalDeductions, totalDeductionsTabLoadingActive]);

  const originalColumns = [
    {
      field: "editRowBtn",
      headerName: "",
      headerAlign: "center",
      align: "center",
      width: 80,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      hideable: false,
      editable: false,
      renderCell: (params) => {
        return props.screenMode === "CREATE" ||
          props.screenMode === "MODIFY" ? (
          <React.Fragment>
            <Tooltip title="Edit Row">
              <Edit
                disabled={
                  props.screenMode === "VIEW" ||
                  props.screenMode === "CANCEL" ||
                  props.screenMode === "APPROVE" ||
                  !new Set(
                    [...validGridRecordsAsNonEditable].map((row) => row.id)
                  ).has(params.row.id)
                }
                fontSize="large"
                sx={{ color: "#004A92", fontWeight: 700 }}
                onClick={() => {
                  // need to enable & disable the complete row disability.
                  makeRowEditableForValidRows(params);
                }}
              ></Edit>
            </Tooltip>
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        );
      },
    },
    {
      field: "deleteBtn",
      headerName: "",
      headerAlign: "center",
      align: "center",
      width: 80,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      hideable: false,
      editable: false,
      renderCell: (params) => {
        return props.screenMode === "CREATE" ||
          props.screenMode === "MODIFY" ? (
          <React.Fragment>
            <Tooltip title="Delete">
              <Delete
                disabled={
                  props.screenMode === "VIEW" ||
                  props.screenMode === "CANCEL" ||
                  props.screenMode === "APPROVE"
                }
                fontSize="large"
                sx={{ color: "#004A92", fontWeight: 700 }}
                onClick={() => {
                  dispatch(
                    DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
                      params.row.paymentMode
                    )
                  );
                  deleteSelectedRow(params);
                }}
              ></Delete>
            </Tooltip>
          </React.Fragment>
        ) : (
          <React.Fragment></React.Fragment>
        );
      },
    },
    {
      field: "paymentMode",
      headerName: "Payment Mode",
      headerAlign: "center",
      align: "left",
      width: 150,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      type: "singleSelect",
      valueOptions: currentGridPaymentModes,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequeNum",
      headerName: "Cheque Number",
      headerAlign: "center",
      type: "string",
      width: 200,
      align: "right",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequeMode",
      headerName: "Cheque Mode",
      headerAlign: "center",
      align: "left",
      width: 150,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      type: "singleSelect",
      valueOptions: chequeModesArray,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequePrintAt",
      headerName: "Cheque Print At",
      headerAlign: "center",
      align: "left",
      width: 150,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      type: "singleSelect",
      valueOptions: chequePrintAtArray,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequePrintLocation",
      headerName: "Cheque Print Location",
      headerAlign: "center",
      align: "left",
      width: 200,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequeShflLocation",
      headerName: "Cheque SHFL Location",
      headerAlign: "center",
      align: "left",
      width: 200,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      type: "singleSelect",
      valueOptions: branchNames,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "bankAccountNum",
      headerName: "Bank Account Number",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: bankAccountNums,
      width: 180,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "favouringName",
      headerName: "Favouring Name",
      headerAlign: "center",
      align: "left",
      width: 200,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "payableAt",
      headerName: "Payable At",
      headerAlign: "center",
      type: "string",
      width: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "bankName",
      headerName: "Bank Name",
      headerAlign: "center",
      type: "string",
      width: 250,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "ifscCode",
      headerName: "IFSC Code",
      headerAlign: "center",
      type: "string",
      width: 150,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "bankBranchName",
      headerName: "Bank Branch",
      headerAlign: "center",
      type: "string",
      width: 180,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "bankAccountType",
      headerName: "Bank Account Type",
      headerAlign: "center",
      type: "string",
      width: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },

    {
      field: "amount",
      headerName: "Amount",
      headerAlign: "center",
      align: "right",
      type: "number",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      renderCell: (params) => {
        let value =
          params.value === undefined ||
          params.value === null ||
          params.value === "" ||
          params.value === "0"
            ? 0
            : Number(params.value) <= 0
            ? 0
            : parseInt(params.value).toLocaleString("en-IN");
        return value;
      },
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "deductionAmount",
      headerName: "Deductions Amount",
      headerAlign: "center",
      align: "right",
      type: "number",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: (params) => {
        let value =
          params.value === undefined ||
          params.value === null ||
          params.value === "" ||
          params.value === "0"
            ? 0
            : Number(params.value) <= 0
            ? 0
            : parseInt(params.value).toLocaleString("en-IN");
        return value;
      },
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "disbAmt",
      headerName: "Net Disbursement Amount",
      headerAlign: "center",
      align: "right",
      type: "number",
      width: 200,
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      renderCell: (params) => {
        let value =
          params.value === undefined ||
          params.value === null ||
          params.value === "" ||
          params.value === "0"
            ? 0
            : Number(params.value) <= 0
            ? 0
            : parseInt(params.value).toLocaleString("en-IN");
        return value;
      },
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequeAllocationMode",
      headerName: "Cheque Allocation Mode",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions:
        Object.keys(disbursementLovData.lovDataValue).length > 0
          ? disbursementLovData?.lovDataValue?.["Cheque Allocation Mode"].map(
              (record) => record.lovValues
            )
          : [],
      width: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "bankBranchShflBank",
      headerName: "Bank Branch SHFL Bank",
      headerAlign: "center",
      type: "singleSelect",
      valueOptions: currentRowShflBankBranches,
      width: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable:
        props.screenMode !== "VIEW" &&
        props.screenMode !== "CANCEL" &&
        props.screenMode !== "APPROVE",
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "bankBranchGl",
      headerName: "Bank Branch GL",
      headerAlign: "center",
      type: "string",
      width: 200,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
    {
      field: "chequeHandoverDate",
      headerName: "Cheque HandOver Date",
      headerAlign: "center",
      align: "right",
      width: 300,
      type: "date",
      hideable: false,
      editable: false,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
      valueFormatter: (params) =>
        params?.value !== null &&
        params?.value !== undefined &&
        params?.value !== ""
          ? dayjs(params?.value).format("DD/MM/YYYY")
          : null,
    },
    {
      field: "chequeAuthorizedDate",
      headerName: "Cheque Authorized Date",
      headerAlign: "center",
      align: "right",
      width: 300,
      type: "date",
      hideable: false,
      editable: false,
      sortable: false,
      filterable: false,
      disableColumnMenu: true,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
      valueFormatter: (params) =>
        params?.value !== null &&
        params?.value !== undefined &&
        params?.value !== ""
          ? dayjs(params?.value).format("DD/MM/YYYY")
          : null,
    },
    {
      field: "requestStatus",
      headerName: "Disbursement Status",
      headerAlign: "center",
      type: "string",
      width: 300,
      align: "left",
      sortable: false,
      filterable: false,
      hideable: false,
      disableColumnMenu: true,
      editable: false,
      cellClassName: (params) =>
        !params.colDef.editable ||
        new Set([...validGridRecordsAsNonEditable].map((row) => row.id)).has(
          params.row.id
        )
          ? "disabledColumnColor"
          : "",
    },
  ];

  const columns =
    props.screenMode === "CREATE" ||
    props.screenMode === "MODIFY" ||
    props.screenMode === "CANCEL"
      ? originalColumns.filter(
          (col) =>
            col.field !== "requestStatus" &&
            col.field !== "chequeHandoverDate" &&
            col.field !== "chequeAuthorizedDate"
        )
      : originalColumns.filter(
          (col) => col.field !== "deleteBtn" && col.field !== "editRowBtn"
        );

  //Delete Button Handler
  const deleteSelectedRow = (params) => {
    setDeleteOperationActive(true);
    dispatch(
      DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(true)
    );
    setTimeout(() => {
      // get the latest records.
      let latestRecords = store.getState().disbursementBalanceTransfer.gridRows;
      let filteredRows = [...latestRecords].filter((data) => {
        return data.id !== params.id;
      });
      if (!deviceModeValue) {
        // for desktop mode only for now.
        const pageSize = 5;
        dispatch(
          DisbursementBalanceTransferReducerAction.updateActivePageNumber(
            Number(Math.ceil(filteredRows.length / pageSize)) === 0
              ? 0
              : Number(Math.ceil(filteredRows.length / pageSize)) - 1
          )
        );
      }
      filteredRows = dynamicAllocationofDeductionsOnGridRecords(
        filteredRows,
        null
      );
      dispatch(
        DisbursementBalanceTransferReducerAction.updateGridRows([
          ...filteredRows,
        ])
      );
      if (filteredRows.length === 0) {
        // when filtered rows was zero then the grid should be similar to the default create page load.
        let updatedColumns = [...columns].map((col) => {
          if (col.field === "paymentMode") {
            col.valueOptions = currentGridPaymentModes;
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
      setTimeout(() => {
        setDeleteOperationActive(false);
        dispatch(
          DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(
            false
          )
        );
      }, 1000);
    }, 1000);
  };

  const handlePageChange = (event, newPage) => {
    let offset = (newPage - 1) * rowsPerPage;
    setPage(newPage);
    setRows([...datarows].slice(offset, offset + rowsPerPage));
  };

  const openAlertHandler = () => {
    setAlert(true);
  };
  const closeAlertHandler = () => {
    setAlert(false);
  };

  const handleOnCellKeyDown = (params, event) => {
    let updatedRecords = [];
    const rowDataIndex = [...datarows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = datarows[rowDataIndex];
    if (activeRecord.paymentMode === "CHEQUE") {
      if (params.field === "chequePrintLocation") {
        if (
          activeRecord.chequePrintAt === "SHFL BRANCH" ||
          activeRecord.chequePrintAt === "CORPORATE"
        ) {
          // if the current row cheque print at is SHFL BRANCH -> then restrict the key press event here.
          event.preventDefault();
          return;
        }
      }
      if (params.field === "chequeShflLocation") {
        // if the current row cheque print at is bank -> then restrict the key press event here.
        if (
          activeRecord.chequePrintAt === "BANK" ||
          activeRecord.chequePrintAt === "CORPORATE"
        ) {
          event.preventDefault();
          return;
        }
      }
      if (params.field === "chequeNum") {
        if (activeRecord.chequeMode === "AUTO") {
          event.preventDefault();
          let updatedColumns = [...gridColumns].map((col) => {
            if (col.field === "chequeNum") {
              col.editable = false;
            }
            return col;
          });
          setGridColumns([...updatedColumns]);
          return;
        } else {
          // manual mode case of cheque mode.
          if (String(event.target.value).length >= 6) {
            event.preventDefault();
          }
        }
      }

      const currentRowChequePrintAt = activeRecord.chequePrintAt;
      if (currentRowChequePrintAt === "CORPORATE") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = false;
          } else if (
            col.field === "chequeShflLocation" ||
            col.field === "chequeAllocationMode"
          ) {
            col.editable = false;
            col.valueOptions = [];
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
      if (currentRowChequePrintAt === "BANK") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = true;
          } else if (
            col.field === "chequeShflLocation" ||
            col.field === "chequeAllocationMode"
          ) {
            col.editable = false;
            col.valueOptions = [];
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }

      if (currentRowChequePrintAt === "SHFL BRANCH") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = false;
          } else if (col.field === "chequeShflLocation") {
            col.editable = true;
            col.valueOptions = branchNames;
          } else if (col.field === "chequeAllocationMode") {
            col.editable = true;
            col.valueOptions =
              Object.keys(disbursementLovData.lovDataValue).length > 0
                ? disbursementLovData?.lovDataValue?.[
                    "Cheque Allocation Mode"
                  ].map((record) => record.lovValues)
                : [];
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
    }

    if (params.field === "favouringName") {
      const nameValue = event.target.value;
      const specialCharPattern = /[!@#$%^~&*()?,":{}|<>\\\-]/;
      const specialCharExistFlag = specialCharPattern.test(nameValue);
      // doesnt need to check null before regexp check since null can't be available on keystore.
      if (specialCharExistFlag || String(nameValue).length > 80) {
        event.preventDefault();
        return;
      }
    }

    if (params.field === "amount") {
      setDeleteOperationActive(true);
      let invalidAmtExist = false;
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.amount = Math.floor(
            Number(params.value) <= 0 || Number(params.value) > 99999999
              ? 0
              : params.value
          );
          if (Number(params.value) > 99999999) {
            invalidAmtExist = true;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      if (invalidAmtExist) {
        setMessage(
          "Amount can't be greater than 9,99,99,999  so reset to default value Zero."
        );
        setAlertType("error");
        openAlertHandler();
      } else if (String(params.value).includes(".")) {
        setMessage("Decimal Value not Acceptable in Amount.");
        setAlertType("error");
        openAlertHandler();
      }

      dispatch(
        DisbursementBalanceTransferReducerAction.updateGridRows([
          ...updatedRecords,
        ])
      );
      setTimeout(() => {
        setDeleteOperationActive(false);
        dispatch(
          DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(
            false
          )
        );
      }, 1000);
    }
  };

  const cellDoubleClickHandler = (params) => {
    const rowDataIndex = [...datarows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = datarows[rowDataIndex];
    if (activeRecord.paymentMode === "CHEQUE") {
      if (params.field === "chequePrintAt") {
        const currentActiveRowChequeMode = activeRecord.chequeMode;
        if (currentActiveRowChequeMode === "MANUAL") {
          const updatedColumns = [...gridColumns].map((col) => {
            if (col.field === "chequePrintAt") {
              col.valueOptions = ["CORPORATE"];
            }
            return col;
          });
          setGridColumns([...updatedColumns]);
        } else {
          setGridColumns([...gridColumns]);
        }
      }

      if (params.field === "chequeNum") {
        let updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequeNum") {
            col.editable = activeRecord.chequeMode === "MANUAL";
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
        return;
      }

      const currentRowChequePrintAt = activeRecord.chequePrintAt;
      if (currentRowChequePrintAt === "CORPORATE") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = false;
          } else if (
            col.field === "chequeShflLocation" ||
            col.field === "chequeAllocationMode"
          ) {
            col.editable = false;
            col.valueOptions = [];
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
      if (currentRowChequePrintAt === "BANK") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = true;
          } else if (
            col.field === "chequeShflLocation" ||
            col.field === "chequeAllocationMode"
          ) {
            col.editable = false;
            col.valueOptions = [];
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }

      if (currentRowChequePrintAt === "SHFL BRANCH") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = false;
          } else if (col.field === "chequeShflLocation") {
            col.editable = true;
            col.valueOptions = branchNames;
          } else if (col.field === "chequeAllocationMode") {
            col.editable = true;
            col.valueOptions =
              Object.keys(disbursementLovData.lovDataValue).length > 0
                ? disbursementLovData?.lovDataValue?.[
                    "Cheque Allocation Mode"
                  ].map((record) => record.lovValues)
                : [];
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
    }
  };

  const isCellEditable = (params) => {
    if (params.field === "deleteBtn" || params.field === "editRowBtn") {
      return false;
    } else {
      if (props.screenMode === "CREATE" || props.screenMode === "MODIFY") {
        const validGridRecordsAsNonEditable =
          store.getState().disbursementBalanceTransfer
            .validGridRecordsAsNonEditable;
        if (validGridRecordsAsNonEditable.length > 0) {
          const disabledValidRecords = new Set(
            validGridRecordsAsNonEditable.map((row) => row.id)
          );
          const cellEditable =
            disabledValidRecords.size > 0
              ? !disabledValidRecords.has(params.row.id)
              : true;
          return cellEditable;
        } else {
          return true;
        }
      } else {
        return false;
      }
    }
  };

  //Cell Change Handler
  const cellChangeHandler = async (params) => {
    setDeleteOperationActive(true);
    dispatch(
      DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(true)
    );
    const rowDataIndex = [...datarows].findIndex((data) => {
      return data.id === params.id;
    });

    let activeRecord = datarows[rowDataIndex];
    let updatedRecords = [];

    if (params.field === "paymentMode") {
      console.log("Current Row payment Mode : " + params.value);
      // this payment Mode editable can be possible only for the payment mode -> neft or rtgs.
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.paymentMode = params.value;
          recordValue.chequeNum = "";
          recordValue.chequeMode = params.value === "DD" ? "AUTO" : "";
          recordValue.chequePrintAt = params.value === "DD" ? "BANK" : "";
          recordValue.chequePrintLocation = "";
          recordValue.chequeShflLocation = "";
          recordValue.favouringName = "";
          recordValue.amount = "0";
          recordValue.ifscCode = "";
          recordValue.payableAt = "";
          recordValue.bankName = "";
          recordValue.bankBranchName = "";
          recordValue.bankAccountNum = "";
          recordValue.bankAccountType = "";
          recordValue.chequeAllocationMode = "";
          recordValue.bankBranchShflBank = "";
          recordValue.bankBranchGl = "";
          recordValue.deductionAmount = "0";
          recordValue.disbAmt = "0";
          return recordValue;
        } else {
          return row;
        }
      });
      dispatch(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          params.value
        )
      );
    }

    if (params.field === "chequeMode") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          // reset the existing record.
          let recordValue = { ...row };
          recordValue.paymentMode = recordValue.paymentMode;
          recordValue.chequeMode = params.value;
          recordValue.chequeNum = "";
          recordValue.chequePrintAt = "";
          recordValue.chequePrintLocation = "";
          recordValue.chequeShflLocation = "";
          recordValue.favouringName = "";
          recordValue.amount = "0";
          recordValue.ifscCode = "";
          recordValue.payableAt = "";
          recordValue.bankName = "";
          recordValue.bankBranchName = "";
          recordValue.bankAccountNum = "";
          recordValue.bankAccountType = "";
          recordValue.chequeAllocationMode = "";
          recordValue.bankBranchShflBank = "";
          recordValue.bankBranchGl = "";
          recordValue.deductionAmount = "0";
          recordValue.disbAmt = "0";
          if (params.value === "MANUAL") {
            recordValue.chequePrintAt = "CORPORATE";
          }
          return recordValue;
        } else {
          return row;
        }
      });
      dispatch(
        DisbursementBalanceTransferReducerAction.updateCurrentRowChequeMode(
          params.value
        )
      );
      const printAtValues =
        params.value === "MANUAL" ? ["CORPORATE"] : chequePrintAtArray;
      DisbursementBalanceTransferReducerAction.updateCurrentRowChequePrintAtValues(
        printAtValues
      );
      if (params.value === "MANUAL") {
        const editableColumns = [
          "deleteBtn",
          "paymentMode",
          "chequeMode",
          "favouringName",
          "amount",
          "bankBranchShflBank",
          "chequeNum",
          "bankBranchGl",
        ];

        let updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintAt") {
            col.valueOptions = printAtValues;
            col.editable = false;
          }
          if (col.field === "chequeNum") {
            col.editable = true;
          }

          if (!editableColumns.includes(col.field)) {
            col.editable = false;
          }
          return col;
        });

        setGridColumns([...updatedColumns]);
      } else {
        // Auto Mode.
        const nonEditableColumns = [
          "chequeNum",
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountNum",
          "bankAccountType",
          "bankBranchGl",
          "deductionAmount",
          "disbAmt",
        ];
        let AutoModeUpdatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintAt") {
            col.valueOptions = printAtValues;
            col.editable = true;
          }
          if (nonEditableColumns.includes(col.field)) {
            col.editable = false;
          } else {
            col.editable = true;
          }
          return col;
        });
        setGridColumns([...AutoModeUpdatedColumns]);
      }
    }

    if (params.field === "chequeNum") {
      let duplicateRecords = [];
      duplicateRecords = [...datarows].filter(
        (row) =>
          row.id !== activeRecord.id && row.chequeNum === String(params.value)
      );
      if (duplicateRecords.length > 0) {
        // means when edited cheque num column, if entered cheque num value from params.value
        // already exist on another record gives 1 record.
        // in case of duplicates don't update records since id of grid record also the cheque num.
        updatedRecords = [...datarows];
        setMessage("Duplicate Cheque Numbers can't be added.");
        setAlertType("error");
        openAlertHandler();
      } else if (
        !/^\d+$/.test(params.value) &&
        String(params.value).length >= 6
      ) {
        // when invalid cheque num exists.
        updatedRecords = [...datarows];
        setMessage("Invalid Cheque Number can't be added.");
        setAlertType("error");
        openAlertHandler();
      } else {
        updatedRecords = [...datarows].map((row) => {
          if (row.id === activeRecord.id) {
            let recordValue = { ...row };
            recordValue.chequeNum = params.value;
            return recordValue;
          } else {
            return row;
          }
        });
      }
    }

    if (params.field === "chequePrintAt") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          // reset the existing record.
          let recordValue = { ...row };
          recordValue.paymentMode = recordValue.paymentMode;
          recordValue.chequeMode = recordValue.chequeMode;
          recordValue.chequePrintAt = params.value;
          recordValue.chequePrintLocation = "";
          recordValue.chequeShflLocation = "";
          recordValue.favouringName = "";
          recordValue.amount = "0";
          recordValue.ifscCode = "";
          recordValue.bankName = "";
          recordValue.bankBranchName = "";
          recordValue.bankAccountNum = "";
          recordValue.bankAccountType = "";
          recordValue.chequeAllocationMode = "";
          recordValue.bankBranchShflBank = "";
          recordValue.bankBranchGl = "";
          recordValue.deductionAmount = "0";
          recordValue.disbAmt = "0";
          if (params.value === "SHFL BRANCH") {
            // get the branch name on the user account.
            const branchData = store.getState().branch.header;
            recordValue.chequeShflLocation = branchData?.branchName;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      if (params.value === "BANK") {
        // enable few required columns.
        const nonEditableColumns = [
          "payableAt",
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountNum",
          "bankAccountType",
          "chequeAllocationMode",
        ];
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequePrintLocation") {
            col.editable = true;
          } else if (col.field === "chequeShflLocation") {
            col.editable = false;
          }
          if (nonEditableColumns.includes(col.field)) {
            col.editable = false;
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      } else if (params.value === "SHFL BRANCH") {
        const nonEditableColumns = [
          "payableAt",
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountNum",
          "bankAccountType",
        ];
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "chequeShflLocation") {
            col.editable = true;
            col.valueOptions = branchNames;
          } else if (col.field === "chequePrintLocation") {
            col.editable = false;
          } else if (col.field === "chequeAllocationMode") {
            col.editable = true;
          }

          if (nonEditableColumns.includes(col.field)) {
            col.editable = false;
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      } else {
        // for corporate selected manually.
        const editableColumns = [
          "deleteBtn",
          "paymentMode",
          "chequeMode",
          "favouringName",
          "amount",
          "bankBranchShflBank",
          "chequePrintAt",
        ];
        const updatedColumns = [...gridColumns].map((col) => {
          if (!editableColumns.includes(col.field)) {
            col.editable = false;
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
    }

    if (params.field === "chequePrintLocation") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.chequePrintLocation = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "chequeShflLocation") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.chequeShflLocation = params.value;
          recordValue.bankBranchShflBank = null;
          recordValue.bankBranchGl = "";
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "favouringName") {
      const nameValue = params.value ? params.value : null;
      const specialCharRegExpPattern = /[!@#$%^~&*()?,":{}|<>\\\-]/;
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          if (nameValue) {
            const specialCharExistFlag =
              specialCharRegExpPattern.test(nameValue);
            recordValue.favouringName = !specialCharExistFlag
              ? String(nameValue).length <= 80
                ? nameValue
                : null
              : null;
          } else {
            // means nameValue is null or undefined.
            recordValue.favouringName = null;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      if (nameValue && specialCharRegExpPattern.test(nameValue)) {
        // means special characters exists is considered as invalid.
        setMessage("Invalid Favouring Name, Since Special Characters Exists.");
        setAlertType("error");
        openAlertHandler();
      }
      if (nameValue && String(nameValue).length > 80) {
        // means special characters exists is considered as invalid.
        setMessage(
          "Invalid Favouring Name, Since length greater than 80 Characters."
        );
        setAlertType("error");
        openAlertHandler();
      }
    }

    if (params.field === "amount") {
      let invalidAmtExist = false;
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.amount = Math.floor(
            Number(params.value) <= 0 || Number(params.value) > 99999999
              ? 0
              : params.value
          );
          if (Number(params.value) > 99999999) {
            invalidAmtExist = true;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      updatedRecords = dynamicAllocationofDeductionsOnGridRecords(
        updatedRecords,
        activeRecord
      );
      if (invalidAmtExist) {
        setMessage(
          "Amount can't be greater than 9,99,99,999  so reset to default value Zero."
        );
        setAlertType("error");
        openAlertHandler();
      } else if (String(params.value).includes(".")) {
        setMessage("Decimal Value not Acceptable in Amount.");
        setAlertType("error");
        openAlertHandler();
      }
    }

    if (params.field === "payableAt") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.payableAt = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "ifscCode") {
      let invalidIfscExist =
        params.value !== "" &&
        params.value !== null &&
        params.value !== undefined &&
        /^[A-Za-z0-9]*$/.test(params.value) &&
        String(params.value).length === 11;

      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.ifscCode = params.value;
          if (String(params.value).length > 11) {
            invalidIfscExist = true;
          }
          return recordValue;
        } else {
          return row;
        }
      });
      if (!invalidIfscExist) {
        setMessage("Invalid Ifsc Code.");
        setAlertType("error");
        openAlertHandler();
      }
    }

    if (params.field === "bankName") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.bankName = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "bankBranchName") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.bankBranchName = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "bankAccountNum") {
      let invalidAccountNumExits =
        params.value !== "" &&
        params.value !== null &&
        params.value !== undefined &&
        String(params.value).length <= 18 &&
        String(params.value).length >= 9 &&
        Number(params.value) > 0 &&
        !String(params.value).includes(".") &&
        /^\d+$/.test(params.value);
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.bankAccountNum = params.value;
          // get the values from the customer details & update other fields.
          const customerDetails =
            store.getState().disbursementBalanceTransfer.customerBankDetails;
          const selectedCustomerData = [...customerDetails].filter(
            (record) => record.bankAccountNum === params.value
          );
          recordValue.bankName = selectedCustomerData[0]?.bankName;
          recordValue.ifscCode = selectedCustomerData[0]?.ifscCode;
          recordValue.bankBranchName = selectedCustomerData[0]?.bankBranchName;
          recordValue.bankAccountType =
            selectedCustomerData[0]?.bankAccountType;
          recordValue.favouringName = selectedCustomerData[0]?.accHoldrName;
          return recordValue;
        } else {
          return row;
        }
      });
      if (!invalidAccountNumExits) {
        setMessage("Bank Account Number is Invalid");
        setAlertType("error");
        openAlertHandler();
      }
    }

    if (params.field === "bankAccountType") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.bankAccountType = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "chequeAllocationMode") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.chequeAllocationMode = params.value;
          recordValue.bankBranchShflBank = null;
          recordValue.bankBranchGl = "";
          return recordValue;
        } else {
          return row;
        }
      });
      if (params.value === "AUTO") {
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "bankBranchShflBank") {
            col.editable = true;
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      } else {
        // manual value selected for cheque allocation mode.
        const updatedColumns = [...gridColumns].map((col) => {
          if (col.field === "bankBranchShflBank") {
            col.editable = true;
          }
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
    }

    if (params.field === "bankBranchShflBank") {
      // based on the selected shfl bank branch update the bank branch Gl col value.
      const branchCodeValue = branchNamesWithCodes.find((branch) => {
        return branch.code === losCustomerData.branchCode;
      });
      // get the code based value from global map data.
      const shflbankBranches =
        store.getState().disbursementBalanceTransfer.shflbankBranches;
      const banks = shflbankBranches[branchCodeValue?.code]?.ledger_details;
      const bankNames = banks.filter((val) => val.branch_name === params.value);
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.bankBranchShflBank = params.value;
          recordValue.bankBranchGl = params.value
            ? bankNames[0]?.gl_account
            : "";
          recordValue.bankBranchKey = params.value
            ? bankNames[0]?.bank_branch_key
            : "";
          return recordValue;
        } else {
          return row;
        }
      });
    }

    if (params.field === "bankBranchGl") {
      updatedRecords = [...datarows].map((row) => {
        if (row.id === activeRecord.id) {
          let recordValue = { ...row };
          recordValue.bankBranchGl = params.value;
          return recordValue;
        } else {
          return row;
        }
      });
    }

    dispatch(
      DisbursementBalanceTransferReducerAction.updateGridRows([
        ...updatedRecords,
      ])
    );
    setTimeout(() => {
      setDeleteOperationActive(false);
      dispatch(
        DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(
          false
        )
      );
    }, 1000);
  };

  const gridRowAddButtonHandler = (autoTriggerEvent) => {
    setDeleteOperationActive(true);
    dispatch(
      DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(true)
    );
    dispatch(
      DisbursementBalanceTransferReducerAction.updateCurrentRowIfscCodes([])
    );
    setTimeout(() => {
      let latestRecords = [
        ...store.getState().disbursementBalanceTransfer.gridRows,
      ];
      let latestCurrentPaymentMode =
        store.getState().disbursementBalanceTransfer.currentRowPaymentMode;
      if (latestCurrentPaymentMode === "DD") {
        const nonEditableColumns = [
          "chequeNum",
          "chequeMode",
          "chequePrintAt",
          "chequePrintLocation",
          "ifscCode",
          "bankName",
          "bankBranchName",
          "bankAccountNum",
          "bankAccountType",
          "chequeAllocationMode",
          "chequeShflLocation",
          "bankBranchGl",
          "deductionAmount",
          "disbAmt",
        ];
        let updatedColumns = [...gridColumns];
        updatedColumns = updatedColumns.map((col) => {
          col.editable = !nonEditableColumns.includes(col.field);
          return col;
        });
        setGridColumns([...updatedColumns]);
      }
      let newrecord = {};
      newrecord.id =
        Math.floor(Math.random() * 100 * Math.random()) + "-" + uuid();
      newrecord.paymentMode = latestCurrentPaymentMode;
      newrecord.chequeMode = latestCurrentPaymentMode === "DD" ? "AUTO" : "";
      newrecord.chequePrintAt = latestCurrentPaymentMode === "DD" ? "BANK" : "";
      newrecord.chequePrintLocation = "";
      newrecord.chequeShflLocation = "";
      newrecord.favouringName = "";
      const netDisbursementAmount = parseInt(
        props.disbursementDetailTabValue.disbAmt - totalDeductions
      );
      newrecord.amount = autoTriggerEvent
        ? props.disbursementDetailTabValue.disbAmt
        : "0";
      newrecord.deductionAmount = autoTriggerEvent ? totalDeductions : "0";
      newrecord.disbAmt = autoTriggerEvent ? netDisbursementAmount : "0";
      newrecord.ifscCode = "";
      newrecord.bankName = "";
      newrecord.bankBranchName = "";
      newrecord.bankAccountNum = "";
      newrecord.bankAccountType = "";
      newrecord.chequeAllocationMode = "";
      newrecord.bankBranchShflBank = "";
      newrecord.bankBranchGl = "";
      latestRecords.push(newrecord);
      if (!deviceModeValue) {
        // for desktop mode only for now.
        const pageSize = 5;
        dispatch(
          DisbursementBalanceTransferReducerAction.updateActivePageNumber(
            Number(Math.ceil(latestRecords.length / pageSize)) === 0
              ? 0
              : Number(Math.ceil(latestRecords.length / pageSize)) - 1
          )
        );
      }
      dispatch(
        DisbursementBalanceTransferReducerAction.updateGridRows([
          ...latestRecords,
        ])
      );
      setTimeout(() => {
        setDeleteOperationActive(false);
        dispatch(
          DisbursementBalanceTransferReducerAction.updateDeleteOperationActive(
            false
          )
        );
        dispatch(
          DisbursementBalanceTransferReducerAction.updateGridAreaSkeletonLoading(
            false
          )
        );
      }, 500);
    }, 500);
  };

  const validateGridRecordsAndAddNewRow = async (
    disbData,
    gridAddBtnClick,
    editRowBtnClick
  ) => {
    await props.validateBalanceTransferGrid(disbData, gridAddBtnClick);
    // get the validation result from redux store and decide the addition of row.
    // setTimeout(() => {
    const isGridValid =
      store.getState().disbursementBalanceTransfer.isGridRecordsValid;
    if (isGridValid) {
      // get the latest grid records and push to valid records.
      const validRecords =
        store.getState().disbursementBalanceTransfer.gridRows;
      dispatch(
        DisbursementBalanceTransferReducerAction.updateValidGridRecordsAsNonEditable(
          [...validRecords]
        )
      );
      if (!editRowBtnClick) {
        // before adding the new record we need to make the existing data rows as disabled.
        gridRowAddButtonHandler(false);
      }
    } else {
      setMessage("Invalid Data Rows Exist.");
      setAlertType("error");
      openAlertHandler();
    }
    // }, 500);
  };

  const makeRowEditableForValidRows = async (params) => {
    const gridRecordsCount =
      store.getState().disbursementBalanceTransfer.gridRows;
    const vaildRowsCount =
      store.getState().disbursementBalanceTransfer
        .validGridRecordsAsNonEditable;
    if (vaildRowsCount === gridRecordsCount) {
      // on making row as editable hold that row as invalid since editable by default and update the current row payment mode.
      dispatch(
        DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
          params.row.paymentMode
        )
      );
      const existingValidRecords =
        store.getState().disbursementBalanceTransfer
          .validGridRecordsAsNonEditable;
      const filteredValidRows = [...existingValidRecords].filter((data) => {
        return data.id !== params.id;
      });
      dispatch(
        DisbursementBalanceTransferReducerAction.updateValidGridRecordsAsNonEditable(
          [...filteredValidRows]
        )
      );
    } else {
      // if valid records count not equal to grid rows, then it indicates that few rows are editable or invalid.
      // then validate those rows again before enabling the current row.
      const currentValidRecords =
        store.getState().disbursementBalanceTransfer
          .validGridRecordsAsNonEditable;
      const isValidRecord = new Set(
        [...currentValidRecords].map((row) => row.id)
      ).has(params.row.id);
      if (isValidRecord) {
        const disbData = { ...props.disbursementDetailTabValue };
        await validateGridRecordsAndAddNewRow(disbData, true, true);
        // setTimeout(() => {
        const isGridValid =
          store.getState().disbursementBalanceTransfer.isGridRecordsValid;
        if (isGridValid) {
          dispatch(
            DisbursementBalanceTransferReducerAction.updateCurrentRowPaymentMode(
              params.row.paymentMode
            )
          );
          const existingValidRecords =
            store.getState().disbursementBalanceTransfer
              .validGridRecordsAsNonEditable;
          const filteredValidRows = [...existingValidRecords].filter((data) => {
            return data.id !== params.id;
          });
          dispatch(
            DisbursementBalanceTransferReducerAction.updateValidGridRecordsAsNonEditable(
              [...filteredValidRows]
            )
          );
        } else {
          setMessage(
            "Few Rows have Error, Please Fix First to Make Current Requested Row as Editable"
          );
          setAlertType("error");
          openAlertHandler();
        }
      }
      // }, 500);
    }
  };

  const onGridPageChange = (newPage) => {
    dispatch(
      DisbursementBalanceTransferReducerAction.updateActivePageNumber(newPage)
    );
  };

  const dynamicAllocationofDeductionsOnGridRow = (
    loopRecord,
    activeRecord,
    isDeductionValueSetFlag,
    validationAmt,
    totalDeductionsValue
  ) => {
    let row = { ...loopRecord };
    let currentIsDeductionValueSetFlag = isDeductionValueSetFlag;
    const netAmount = Number(loopRecord.amount) - Number(totalDeductionsValue);
    if (activeRecord && loopRecord.id === activeRecord.id) {
      if (!currentIsDeductionValueSetFlag && netAmount > validationAmt) {
        row.amount = loopRecord.amount;
        row.deductionAmount = totalDeductionsValue;
        row.disbAmt = netAmount;
        currentIsDeductionValueSetFlag = true;
      } else {
        row.amount = loopRecord.amount;
        row.deductionAmount = 0;
        row.disbAmt = loopRecord.amount;
      }
    } else {
      if (!currentIsDeductionValueSetFlag && netAmount > validationAmt) {
        row.amount = loopRecord.amount;
        row.deductionAmount = totalDeductionsValue;
        row.disbAmt = netAmount;
        currentIsDeductionValueSetFlag = true;
      } else {
        row.amount = loopRecord.amount;
        row.deductionAmount = 0;
        row.disbAmt = loopRecord.amount;
      }
    }
    return {
      loopRecord: row,
      deductionSetFlag: currentIsDeductionValueSetFlag,
    };
  };

  const dynamicAllocationofDeductionsOnGridRecords = (
    updatedRecords,
    activeRecord
  ) => {
    // this code runs for amount field value change.
    const totalDeductionsValue =
      store.getState().disbursementBalanceTransfer.totalDeductions;

    let balanceTransferRecords = [];
    let isDeductionValueSetFlag = false;
    let deductionActiveRecordIds = new Set();
    // Rtgs
    balanceTransferRecords = [...updatedRecords].map((record) => {
      if (record.paymentMode === "RTGS" && !isDeductionValueSetFlag) {
        const updatedRowObject = dynamicAllocationofDeductionsOnGridRow(
          record,
          activeRecord,
          isDeductionValueSetFlag,
          200000,
          totalDeductionsValue
        );
        const updatedRow = updatedRowObject.loopRecord;
        if (updatedRowObject.deductionSetFlag) {
          // if deduction is set gather this row.
          isDeductionValueSetFlag = true;
          deductionActiveRecordIds.add(updatedRow.id);
        } else {
          deductionActiveRecordIds.delete(updatedRow.id);
        }
        return updatedRow;
      } else {
        return record;
      }
    });

    // neft
    balanceTransferRecords = [...balanceTransferRecords].map((record) => {
      if (record.paymentMode === "NEFT" && !isDeductionValueSetFlag) {
        const updatedRowObject = dynamicAllocationofDeductionsOnGridRow(
          record,
          activeRecord,
          isDeductionValueSetFlag,
          0,
          totalDeductionsValue
        );
        const updatedRow = updatedRowObject.loopRecord;
        if (updatedRowObject.deductionSetFlag) {
          // if deduction is set gather this row.
          isDeductionValueSetFlag = true;
          deductionActiveRecordIds.add(updatedRow.id);
        } else {
          deductionActiveRecordIds.delete(updatedRow.id);
        }
        return updatedRow;
      } else {
        return record;
      }
    });

    // DD
    balanceTransferRecords = [...balanceTransferRecords].map((record) => {
      if (record.paymentMode === "DD" && !isDeductionValueSetFlag) {
        const updatedRowObject = dynamicAllocationofDeductionsOnGridRow(
          record,
          activeRecord,
          isDeductionValueSetFlag,
          0,
          totalDeductionsValue
        );
        const updatedRow = updatedRowObject.loopRecord;
        if (updatedRowObject.deductionSetFlag) {
          // if deduction is set gather this row.
          isDeductionValueSetFlag = true;
          deductionActiveRecordIds.add(updatedRow.id);
        } else {
          deductionActiveRecordIds.delete(updatedRow.id);
        }
        return updatedRow;
      } else {
        return record;
      }
    });

    // Cheque.
    balanceTransferRecords = [...balanceTransferRecords].map((record) => {
      if (record.paymentMode === "CHEQUE" && !isDeductionValueSetFlag) {
        const updatedRowObject = dynamicAllocationofDeductionsOnGridRow(
          record,
          activeRecord,
          isDeductionValueSetFlag,
          0,
          totalDeductionsValue
        );
        const updatedRow = updatedRowObject.loopRecord;
        if (updatedRowObject.deductionSetFlag) {
          // if deduction is set gather this row.
          isDeductionValueSetFlag = true;
          deductionActiveRecordIds.add(updatedRow.id);
        } else {
          deductionActiveRecordIds.delete(updatedRow.id);
        }
        return updatedRow;
      } else {
        return record;
      }
    });

    // for safe side override non deductionActiveRecordIds values to zero.
    balanceTransferRecords = balanceTransferRecords.map((record) => {
      let row = { ...record };
      if (!deductionActiveRecordIds.has(row.id)) {
        row.amount = record.amount;
        row.deductionAmount = 0;
        row.disbAmt = record.amount;
      }
      return row;
    });

    return balanceTransferRecords;
  };

  return (
    <React.Fragment>
      <Box sx={{ float: "right", margin: "14px 8px 8px 8px" }}>
        {props.screenMode !== "VIEW" &&
          props.screenMode !== "CANCEL" &&
          props.screenMode !== "APPROVE" &&
          !loading &&
          !totalDeductionsTabLoadingActive && (
            <Tooltip title="Add(Ctrl+A)" placement="top">
              <Button
                size="small"
                variant="contained"
                disabled={
                  props.screenMode === "VIEW" ||
                  props.screenMode === "CANCEL" ||
                  props.screenMode === "APPROVE" ||
                  deleteOperationActive ||
                  totalDeductionsTabLoadingActive
                }
                onClick={() => {
                  // new spec for multi payment in grid on 05-09-2024
                  // on manual btn click event validate all the existing grid rows.
                  //  if rows are valid with out error then proceed for adding new row.
                  setTimeout(() => {
                    const disbData = { ...props.disbursementDetailTabValue };
                    const existingGridRecords =
                      store.getState().disbursementBalanceTransfer.gridRows;
                    if (existingGridRecords.length > 0) {
                      validateGridRecordsAndAddNewRow(disbData, true, false);
                    } else {
                      gridRowAddButtonHandler(false);
                    }
                  }, 500);
                }}
                ref={addRowRef}
              >
                <Add fontSize="small" />
              </Button>
            </Tooltip>
          )}
      </Box>
      {useMediaQuery("(min-width:1200px)") && (
        <React.Fragment>
          {loading ||
            (totalDeductionsTabLoadingActive && (
              <Box sx={{ backgroundColor: "white", minHeight: "320px" }}>
                <Skeleton
                  variant="rounded"
                  animation="wave"
                  width="100%"
                  height={
                    window.innerHeight > 650
                      ? window.innerHeight / 1.8
                      : "260px"
                  }
                />
              </Box>
            ))}
          {!loading && !totalDeductionsTabLoadingActive && (
            <Box
              sx={{
                "& .disabledColumnColor": { backgroundColor: "#D7D7D7" },
              }}
            >
              <CustomDataGrid
                noDataMessage="No Data."
                noDataOnFilterMessage="No Data on Applied Filter."
                density={"comfortable"}
                rowHeight={60}
                rows={datarows}
                columns={gridColumns}
                pageSize={5}
                pageSizeOptions={[5]}
                pageValue={
                  props.screenMode === "CREATE" || props.screenMode === "MODIFY"
                    ? activePageNumber
                    : 0
                }
                onCellEditCommit={(params) => {
                  if (
                    params.field !== "deleteBtn" ||
                    params.field !== "editRowBtn"
                  ) {
                    cellChangeHandler(params);
                  }
                }}
                onCellKeyDown={(params, event) => {
                  if (
                    params.field !== "deleteBtn" ||
                    params.field !== "editRowBtn"
                  ) {
                    const validRecords =
                      store.getState().disbursementBalanceTransfer
                        .validGridRecordsAsNonEditable;
                    const isValidRecord = new Set(
                      [...validRecords].map((row) => row.id)
                    ).has(params.row.id);
                    // is isValidRecord means the row is already disabled , so prevent this event.
                    if (isValidRecord) {
                      event.preventDefault();
                      return;
                    } else {
                      handleOnCellKeyDown(params, event);
                    }
                  }
                }}
                onCellDoubleClick={(params, event) => {
                  if (
                    params.field !== "deleteBtn" ||
                    params.field !== "editRowBtn"
                  ) {
                    if (
                      props.screenMode === "CREATE" ||
                      props.screenMode === "MODIFY"
                    ) {
                      const validRecords =
                        store.getState().disbursementBalanceTransfer
                          .validGridRecordsAsNonEditable;
                      const isValidRecord = new Set(
                        [...validRecords].map((row) => row.id)
                      ).has(params.row.id);
                      // is isValidRecord means the row is already disabled , so prevent this event.
                      if (isValidRecord) {
                        event.preventDefault();
                        return;
                      } else {
                        cellDoubleClickHandler(params);
                      }
                    }
                  }
                }}
                loading={deleteOperationActive}
                gridLazyLoad={onGridPageChange}
                onSortModelChange={() => {}}
                isCellEditable={isCellEditable}
              />
            </Box>
          )}
        </React.Fragment>
      )}
      {useMediaQuery("(max-width:1200px)") && (
        <Paper sx={{ marginBottom: "8px", padding: "0px 16px 8px 16px" }}>
          <React.Fragment>
            <Grid
              container
              item
              direction="row"
              alignItems="flex-end"
              justifyContent="flex-end"
              sx={{ height: "60px", bgcolor: "white" }}
            >
              {totalRowsCount > 10 && (
                <Typography
                  sx={{
                    mr: 2,
                    color: "#004A92",
                    fontWeight: 700,
                  }}
                >
                  {"Page Max Records : " + rowsPerPage}
                </Typography>
              )}
              <Typography
                padding="1px"
                sx={{
                  color: "#004A92",
                  fontWeight: 700,
                }}
              >
                {"Total Records : " + totalRowsCount}
              </Typography>
              <Pagination
                count={totalPageCount}
                color="primary"
                onChange={handlePageChange}
                page={page}
                renderItem={(item) => (
                  <PaginationItem
                    slots={{ previous: ArrowBack, next: ArrowForward }}
                    {...item}
                  />
                )}
              />
            </Grid>
            <Grid container>
              <Box
                sx={{
                  height: accordianOpen
                    ? window.innerHeight - 540
                    : window.innerHeight - 250,
                  overflow: "auto",
                  flex: "1 auto",
                  marginBottom: "16px",
                }}
              >
                {gridColumns &&
                  rows.map((row, index) => (
                    <React.Fragment>
                      <Grid
                        container
                        direction="column"
                        sx={{ flex: "1 auto" }}
                      >
                        <Card>
                          <CardHeader
                            subheader={
                              row.paymentMode +
                              " - " +
                              row.bankName +
                              " - " +
                              row.bankAccountNum
                            }
                            subheaderTypographyProps={{
                              color: "#004A92",
                              fontWeight: "700",
                            }}
                            action={
                              <React.Fragment>
                                {props.screenMode !== "VIEW" && (
                                  <IconButton size="small">
                                    <Delete
                                      fontSize="small"
                                      sx={{ color: "#004A92", fontWeight: 700 }}
                                      onClick={() => {
                                        let params = {
                                          id: row.id,
                                        };
                                        deleteSelectedRow(params);
                                      }}
                                    />
                                  </IconButton>
                                )}
                              </React.Fragment>
                            }
                            sx={{
                              textAlign: "left",
                              padding: "16px 16px 0px 16px !important",
                            }}
                          />
                          <CardContent sx={{}}>
                            <Grid
                              container
                              item
                              direction="column"
                              alignItems="flex-start"
                              justifyContent="flex-start"
                              sx={{}}
                            >
                              <Grid
                                container
                                direction="row"
                                alignItems="flex-start"
                                justifyContent="flex-start"
                              >
                                <React.Fragment>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Payment Mode"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    <span
                                      style={{
                                        display: "flex",
                                      }}
                                    >
                                      {` : `}
                                      {props.screenMode !== "VIEW" && (
                                        <CustomAutoComplete
                                          variant="standard"
                                          type="text"
                                          disabled={
                                            props.screenMode === "VIEW" ||
                                            props.screenMode === "CANCEL" ||
                                            props.screenMode === "APPROVE" ||
                                            !gridColumns.filter(
                                              (col) =>
                                                col.field === "paymentMode"
                                            )[0]?.editable
                                          }
                                          placeholder=" Payment Mode "
                                          autoCompleteValues={
                                            currentGridPaymentModes
                                          }
                                          value={row.paymentMode}
                                          onChange={(e, value) => {
                                            let params = {
                                              id: row.id,
                                              field: "paymentMode",
                                              value: value,
                                            };
                                            cellChangeHandler(params);
                                          }}
                                        />
                                      )}
                                      {props.screenMode === "VIEW" && (
                                        <React.Fragment>
                                          {row.paymentMode
                                            ? row.paymentMode
                                            : "------------"}
                                        </React.Fragment>
                                      )}
                                    </span>
                                  </Grid>

                                  {(row.paymentMode === "CHEQUE" ||
                                    row.paymentMode === "DD") && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Mode"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        <span
                                          style={{
                                            display: "flex",
                                          }}
                                        >
                                          {` : `}
                                          {props.screenMode !== "VIEW" && (
                                            <CustomAutoComplete
                                              variant="standard"
                                              type="text"
                                              disabled={
                                                props.screenMode === "VIEW" ||
                                                !gridColumns.filter(
                                                  (col) =>
                                                    col.field === "chequeMode"
                                                )[0]?.editable
                                              }
                                              placeholder=" Cheque Mode "
                                              autoCompleteValues={[
                                                ...chequeModesArray,
                                              ]}
                                              value={row.chequeMode}
                                              onChange={(e, value) => {
                                                let params = {
                                                  id: row.id,
                                                  field: "chequeMode",
                                                  value: value,
                                                };
                                                cellChangeHandler(params);
                                              }}
                                            />
                                          )}
                                          {props.screenMode === "VIEW" && (
                                            <React.Fragment>
                                              {row.chequeMode
                                                ? row.chequeMode
                                                : "------------"}
                                            </React.Fragment>
                                          )}
                                        </span>
                                      </Grid>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Print At"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        <span
                                          style={{
                                            display: "flex",
                                          }}
                                        >
                                          {` : `}
                                          {props.screenMode !== "VIEW" && (
                                            <CustomAutoComplete
                                              variant="standard"
                                              type="text"
                                              disabled={
                                                props.screenMode === "VIEW" ||
                                                !gridColumns.filter(
                                                  (col) =>
                                                    col.field ===
                                                    "chequePrintAt"
                                                )[0]?.editable
                                              }
                                              placeholder=" Cheque Print At "
                                              autoCompleteValues={[
                                                ...chequePrintAtArray,
                                              ]}
                                              value={row.chequePrintAt}
                                              onChange={(e, value) => {
                                                let params = {
                                                  id: row.id,
                                                  field: "chequePrintAt",
                                                  value: value,
                                                };
                                                cellChangeHandler(params);
                                              }}
                                            />
                                          )}
                                          {props.screenMode === "VIEW" && (
                                            <React.Fragment>
                                              {row.chequePrintAt
                                                ? row.chequePrintAt
                                                : "------------"}
                                            </React.Fragment>
                                          )}
                                        </span>
                                      </Grid>

                                      {row.paymentMode === "CHEQUE" && (
                                        <React.Fragment>
                                          <Grid item xs={7} md={5}>
                                            <Typography padding="1px">
                                              {"Cheque Print Location"}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={5} md={7}>
                                            {` : `}
                                            {props.screenMode !== "VIEW" && (
                                              <TextField
                                                autoComplete="off"
                                                sx={{
                                                  "& .MuiInputBase-input": {
                                                    overflow: "hidden",
                                                    textOverflow: "ellipsis",
                                                  },
                                                }}
                                                inputProps={{
                                                  style: {
                                                    textAlign: `left`,
                                                    fontSize: "12px",
                                                  },
                                                }}
                                                type="text"
                                                variant="standard"
                                                value={row.chequePrintLocation}
                                                placeholder="Cheque Print Location"
                                                disabled={
                                                  props.screenMode === "VIEW" ||
                                                  !gridColumns.filter(
                                                    (col) =>
                                                      col.field ===
                                                      "chequePrintLocation"
                                                  )[0]?.editable
                                                }
                                                onChange={(event) => {
                                                  let params = {
                                                    id: row.id,
                                                    field:
                                                      "chequePrintLocation",
                                                    value: event.target.value,
                                                  };
                                                  cellChangeHandler(params);
                                                }}
                                              />
                                            )}
                                            {props.screenMode === "VIEW" && (
                                              <React.Fragment>
                                                {row.chequePrintLocation
                                                  ? row.chequePrintLocation
                                                  : "------------"}
                                              </React.Fragment>
                                            )}
                                          </Grid>
                                          <Grid item xs={7} md={5}>
                                            <Typography padding="1px">
                                              {"Cheque Shfl Location"}
                                            </Typography>
                                          </Grid>
                                          <Grid item xs={5} md={7}>
                                            <span
                                              style={{
                                                display: "flex",
                                              }}
                                            >
                                              {` : `}
                                              {props.screenMode !== "VIEW" && (
                                                <CustomAutoComplete
                                                  variant="standard"
                                                  type="text"
                                                  value={row.chequeShflLocation}
                                                  placeholder=" Cheque Shfl Location "
                                                  disabled={
                                                    props.screenMode ===
                                                      "VIEW" ||
                                                    !gridColumns.filter(
                                                      (col) =>
                                                        col.field ===
                                                        "chequeShflLocation"
                                                    )[0]?.editable
                                                  }
                                                  autoCompleteValues={
                                                    gridColumns.filter(
                                                      (col) =>
                                                        col.field ===
                                                        "chequeShflLocation"
                                                    )[0]?.valueOptions
                                                  }
                                                  onChange={(event, value) => {
                                                    let params = {
                                                      id: row.id,
                                                      field:
                                                        "chequeShflLocation",
                                                      value: value,
                                                    };
                                                    cellChangeHandler(params);
                                                  }}
                                                />
                                              )}
                                              {props.screenMode === "VIEW" && (
                                                <React.Fragment>
                                                  {row.chequeShflLocation
                                                    ? row.chequeShflLocation
                                                    : "------------"}
                                                </React.Fragment>
                                              )}
                                            </span>
                                          </Grid>
                                        </React.Fragment>
                                      )}
                                    </React.Fragment>
                                  )}

                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Favouring Name"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}
                                    {props.screenMode !== "VIEW" && (
                                      <TextField
                                        autoComplete="off"
                                        sx={{
                                          "& .MuiInputBase-input": {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          },
                                        }}
                                        inputProps={{
                                          style: {
                                            textAlign: `left`,
                                            fontSize: "12px",
                                          },
                                        }}
                                        type="text"
                                        variant="standard"
                                        value={row.favouringName}
                                        placeholder="Favouring Name"
                                        disabled={
                                          props.screenMode === "VIEW" ||
                                          !gridColumns.filter(
                                            (col) =>
                                              col.field === "favouringName"
                                          )[0]?.editable
                                        }
                                        onChange={(event) => {
                                          let params = {
                                            id: row.id,
                                            field: "favouringName",
                                            value: event.target.value,
                                          };
                                          cellChangeHandler(params);
                                        }}
                                      />
                                    )}
                                    {props.screenMode === "VIEW" && (
                                      <React.Fragment>
                                        {row.favouringName
                                          ? row.favouringName
                                          : "------------"}
                                      </React.Fragment>
                                    )}
                                  </Grid>
                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Amount"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}
                                    {props.screenMode !== "VIEW" && (
                                      <TextField
                                        autoComplete="off"
                                        sx={{
                                          "& .MuiInputBase-input": {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          },
                                        }}
                                        inputProps={{
                                          inputMode: "numeric",
                                          pattern: "[0-9]*",
                                          style: {
                                            textAlign: `left`,
                                            fontSize: "12px",
                                          },
                                        }}
                                        type="number"
                                        variant="standard"
                                        value={row.amount}
                                        placeholder="Amount"
                                        disabled={
                                          props.screenMode === "VIEW" ||
                                          !gridColumns.filter(
                                            (col) => col.field === "amount"
                                          )[0]?.editable
                                        }
                                        onChange={(event) => {
                                          let params = {
                                            id: row.id,
                                            field: "amount",
                                            value: event.target.value,
                                          };
                                          cellChangeHandler(params);
                                        }}
                                        onBlur={() => {}}
                                        onKeyDown={(e) => {
                                          if (
                                            e.key === "e" ||
                                            e.key === "E" ||
                                            e.key === "-" ||
                                            e.key === "+"
                                          ) {
                                            e.preventDefault();
                                          }
                                        }}
                                      />
                                    )}
                                    {props.screenMode === "VIEW" && (
                                      <React.Fragment>
                                        {parseInt(row.amount).toLocaleString(
                                          "en-IN"
                                        )}
                                      </React.Fragment>
                                    )}
                                  </Grid>
                                  {row.paymentMode === "DD" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Payable At"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        {props.screenMode !== "VIEW" && (
                                          <TextField
                                            autoComplete="off"
                                            sx={{
                                              "& .MuiInputBase-input": {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              },
                                            }}
                                            inputProps={{
                                              style: {
                                                textAlign: `left`,
                                                fontSize: "12px",
                                              },
                                            }}
                                            type="text"
                                            variant="standard"
                                            value={row.payableAt}
                                            placeholder="Payable At"
                                            disabled={
                                              props.screenMode === "VIEW" ||
                                              !gridColumns.filter(
                                                (col) =>
                                                  col.field === "payableAt"
                                              )[0]?.editable
                                            }
                                            onChange={(event) => {
                                              let params = {
                                                id: row.id,
                                                field: "payableAt",
                                                value: event.target.value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        )}
                                        {props.screenMode === "VIEW" && (
                                          <React.Fragment>
                                            {row.payableAt
                                              ? row.payableAt
                                              : "------------"}
                                          </React.Fragment>
                                        )}
                                      </Grid>
                                    </React.Fragment>
                                  )}

                                  {(row.paymentMode === "NEFT" ||
                                    row.paymentMode === "RTGS") && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Account Number"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        {props.screenMode !== "VIEW" && (
                                          <CustomAutoComplete
                                            type="text"
                                            variant="standard"
                                            value={row.bankAccountNum}
                                            placeholder="Account Number"
                                            disabled={
                                              props.screenMode === "VIEW" ||
                                              !gridColumns.filter(
                                                (col) =>
                                                  col.field === "bankAccountNum"
                                              )[0]?.editable
                                            }
                                            autoCompleteValues={
                                              gridColumns.filter(
                                                (col) =>
                                                  col.field === "bankAccountNum"
                                              )[0]?.valueOptions
                                            }
                                            onChange={(event, value) => {
                                              let params = {
                                                id: row.id,
                                                field: "bankAccountNum",
                                                value: value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        )}
                                        {props.screenMode === "VIEW" && (
                                          <React.Fragment>
                                            {row.bankAccountNum
                                              ? row.bankAccountNum
                                              : "------------"}
                                          </React.Fragment>
                                        )}
                                      </Grid>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Bank Name"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        {props.screenMode !== "VIEW" && (
                                          <TextField
                                            autoComplete="off"
                                            sx={{
                                              "& .MuiInputBase-input": {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              },
                                            }}
                                            inputProps={{
                                              style: {
                                                textAlign: `left`,
                                                fontSize: "12px",
                                              },
                                            }}
                                            type="text"
                                            variant="standard"
                                            value={row.bankName}
                                            placeholder=" Bank Name "
                                            disabled={
                                              props.screenMode === "VIEW" ||
                                              !gridColumns.filter(
                                                (col) =>
                                                  col.field === "bankName"
                                              )[0]?.editable
                                            }
                                            onChange={(event) => {
                                              let params = {
                                                id: row.id,
                                                field: "bankName",
                                                value: event.target.value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        )}
                                        {props.screenMode === "VIEW" && (
                                          <React.Fragment>
                                            {row.bankName
                                              ? row.bankName
                                              : "------------"}
                                          </React.Fragment>
                                        )}
                                      </Grid>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Ifsc Code"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        {props.screenMode !== "VIEW" && (
                                          <TextField
                                            autoComplete="off"
                                            sx={{
                                              "& .MuiInputBase-input": {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              },
                                            }}
                                            inputProps={{
                                              style: {
                                                textAlign: `left`,
                                                fontSize: "12px",
                                              },
                                            }}
                                            type="text"
                                            variant="standard"
                                            value={row.ifscCode}
                                            placeholder=" Ifsc Code "
                                            disabled={
                                              props.screenMode === "VIEW" ||
                                              !gridColumns.filter(
                                                (col) =>
                                                  col.field === "ifscCode"
                                              )[0]?.editable
                                            }
                                            onChange={(event) => {
                                              let params = {
                                                id: row.id,
                                                field: "ifscCode",
                                                value: event.target.value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        )}
                                        {props.screenMode === "VIEW" && (
                                          <React.Fragment>
                                            {row.ifscCode
                                              ? row.ifscCode
                                              : "------------"}
                                          </React.Fragment>
                                        )}
                                      </Grid>

                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Bank Branch"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        {props.screenMode !== "VIEW" && (
                                          <TextField
                                            autoComplete="off"
                                            sx={{
                                              "& .MuiInputBase-input": {
                                                overflow: "hidden",
                                                textOverflow: "ellipsis",
                                              },
                                            }}
                                            inputProps={{
                                              style: {
                                                textAlign: `left`,
                                                fontSize: "12px",
                                              },
                                            }}
                                            type="text"
                                            variant="standard"
                                            value={row.bankBranchName}
                                            placeholder=" Bank Branch "
                                            disabled={
                                              props.screenMode === "VIEW" ||
                                              !gridColumns.filter(
                                                (col) =>
                                                  col.field === "bankBranchName"
                                              )[0]?.editable
                                            }
                                            onChange={(event) => {
                                              let params = {
                                                id: row.id,
                                                field: "bankBranchName",
                                                value: event.target.value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        )}
                                        {props.screenMode === "VIEW" && (
                                          <React.Fragment>
                                            {row.bankBranchName
                                              ? row.bankBranchName
                                              : "------------"}
                                          </React.Fragment>
                                        )}
                                      </Grid>

                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Account Type"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        <span
                                          style={{
                                            display: "flex",
                                          }}
                                        >
                                          {` : `}
                                          {props.screenMode !== "VIEW" && (
                                            <TextField
                                              autoComplete="off"
                                              sx={{
                                                "& .MuiInputBase-input": {
                                                  overflow: "hidden",
                                                  textOverflow: "ellipsis",
                                                },
                                              }}
                                              inputProps={{
                                                style: {
                                                  textAlign: `left`,
                                                  fontSize: "12px",
                                                },
                                              }}
                                              variant="standard"
                                              type="text"
                                              disabled={
                                                props.screenMode === "VIEW" ||
                                                !gridColumns.filter(
                                                  (col) =>
                                                    col.field ===
                                                    "bankAccountType"
                                                )[0]?.editable
                                              }
                                              placeholder=" Account Type "
                                              value={row.bankAccountType}
                                              onChange={(event) => {
                                                let params = {
                                                  id: row.id,
                                                  field: "bankAccountType",
                                                  value: event.target.value,
                                                };
                                                cellChangeHandler(params);
                                              }}
                                            />
                                          )}
                                          {props.screenMode === "VIEW" && (
                                            <React.Fragment>
                                              {row.bankAccountType
                                                ? row.bankAccountType
                                                : "------------"}
                                            </React.Fragment>
                                          )}
                                        </span>
                                      </Grid>
                                    </React.Fragment>
                                  )}

                                  {row.paymentMode === "CHEQUE" && (
                                    <React.Fragment>
                                      <Grid item xs={7} md={5}>
                                        <Typography padding="1px">
                                          {"Cheque Allocation Mode"}
                                        </Typography>
                                      </Grid>
                                      <Grid item xs={5} md={7}>
                                        {` : `}
                                        {props.screenMode !== "VIEW" && (
                                          <CustomAutoComplete
                                            variant="standard"
                                            type="text"
                                            disabled={
                                              props.screenMode === "VIEW" ||
                                              !gridColumns.filter(
                                                (col) =>
                                                  col.field ===
                                                  "chequeAllocationMode"
                                              )[0]?.editable
                                            }
                                            autoCompleteValues={
                                              gridColumns.filter(
                                                (col) =>
                                                  col.field ===
                                                  "chequeAllocationMode"
                                              )[0]?.valueOptions
                                            }
                                            value={row.chequeAllocationMode}
                                            placeholder=" Cheque Allocation Mode "
                                            onChange={(e, value) => {
                                              let params = {
                                                id: row.id,
                                                field: "chequeAllocationMode",
                                                value: value,
                                              };
                                              cellChangeHandler(params);
                                            }}
                                          />
                                        )}
                                        {props.screenMode === "VIEW" && (
                                          <React.Fragment>
                                            {row.chequeAllocationMode
                                              ? row.chequeAllocationMode
                                              : "------------"}
                                          </React.Fragment>
                                        )}
                                      </Grid>
                                    </React.Fragment>
                                  )}

                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Bank Branch SHFL Bank"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}
                                    {props.screenMode !== "VIEW" && (
                                      <CustomAutoComplete
                                        type="text"
                                        variant="standard"
                                        placeholder=" Bank Branch SHFL Bank "
                                        disabled={
                                          props.screenMode === "VIEW" ||
                                          !gridColumns.filter(
                                            (col) =>
                                              col.field === "bankBranchShflBank"
                                          )[0]?.editable
                                        }
                                        autoCompleteValues={[
                                          ...currentRowShflBankBranches,
                                        ]}
                                        value={row.bankBranchShflBank}
                                        onChange={(e, value) => {
                                          let params = {
                                            id: row.id,
                                            field: "bankBranchShflBank",
                                            value: value,
                                          };
                                          cellChangeHandler(params);
                                        }}
                                      />
                                    )}
                                    {props.screenMode === "VIEW" && (
                                      <React.Fragment>
                                        {row.bankBranchShflBank
                                          ? row.bankBranchShflBank
                                          : "------------"}
                                      </React.Fragment>
                                    )}
                                  </Grid>

                                  <Grid item xs={7} md={5}>
                                    <Typography padding="1px">
                                      {"Bank Branch GL"}
                                    </Typography>
                                  </Grid>
                                  <Grid item xs={5} md={7}>
                                    {` : `}
                                    {props.screenMode !== "VIEW" && (
                                      <TextField
                                        autoComplete="off"
                                        sx={{
                                          "& .MuiInputBase-input": {
                                            overflow: "hidden",
                                            textOverflow: "ellipsis",
                                          },
                                        }}
                                        inputProps={{
                                          style: {
                                            textAlign: `left`,
                                            fontSize: "12px",
                                          },
                                        }}
                                        type="text"
                                        variant="standard"
                                        value={row.bankBranchGl}
                                        placeholder="Bank Branch GL"
                                        disabled={
                                          props.screenMode === "VIEW" ||
                                          !gridColumns.filter(
                                            (col) =>
                                              col.field === "bankBranchGl"
                                          )[0]?.editable
                                        }
                                        onChange={(event) => {
                                          let params = {
                                            id: row.id,
                                            field: "bankBranchGl",
                                            value: event.target.value,
                                          };
                                          cellChangeHandler(params);
                                        }}
                                      />
                                    )}
                                    {props.screenMode === "VIEW" && (
                                      <React.Fragment>
                                        {row.bankBranchGl
                                          ? row.bankBranchGl
                                          : "------------"}
                                      </React.Fragment>
                                    )}
                                  </Grid>
                                </React.Fragment>
                              </Grid>
                            </Grid>
                          </CardContent>
                        </Card>
                      </Grid>
                      <Divider />
                    </React.Fragment>
                  ))}
                {rows.length === 0 && (
                  <NoDataFound
                    message={"No Data Found."}
                    imageStyle={{
                      marginTop:
                        accordianOpen && window.innerHeight < 1000
                          ? "20px"
                          : "20%",
                    }}
                  />
                )}
              </Box>
            </Grid>
          </React.Fragment>
        </Paper>
      )}
      <Snackbar
        open={alert}
        autoHideDuration={6000}
        anchorOrigin={{ vertical, horizontal }}
        onClose={closeAlertHandler}
      >
        <Alert
          onClose={closeAlertHandler}
          severity={alertType}
          variant="filled"
          sx={{ width: "100%" }}
        >
          {message}
        </Alert>
      </Snackbar>
    </React.Fragment>
  );
};

export default BalanceTransfer;
